

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const REJECTAPPRAISALREAPPLY= createAsyncThunk(
  "rejectAppraisalReapply/rejectAppraisalReapply",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const rejectAppraisalReapplySlice = createSlice({
  name: "rejectAppraisalReapplySlice",
  initialState: {
    rejectAppraisalReapply: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfrejectAppraisalReapply: (state) => {
        state.rejectAppraisalReapply.loading = false
        state.rejectAppraisalReapply.error = false
        state.rejectAppraisalReapply.data = []
        state.rejectAppraisalReapply.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(REJECTAPPRAISALREAPPLY.fulfilled, (state, action) => {
      state.rejectAppraisalReapply = {
        ...state.rejectAppraisalReapply,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTAPPRAISALREAPPLY.pending, (state, action) => {
      state.rejectAppraisalReapply = {
        ...state.rejectAppraisalReapply,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(REJECTAPPRAISALREAPPLY.rejected, (state, action) => {
      state.rejectAppraisalReapply = {
        ...state.rejectAppraisalReapply,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const rejectAppraisalReapplyAction = {
    REJECTAPPRAISALREAPPLY,
};

export { rejectAppraisalReapplyAction };
export default rejectAppraisalReapplySlice.reducer;
export const {setInitialStateOfrejectAppraisalReapply} = rejectAppraisalReapplySlice.actions
